import styled from "styled-components";

const Header = styled.header`
  margin: 1em 0;
  @media (max-width: 576px) {
    margin: 0.8em 0;
  }
`;

export default Header;
